import { SortValue } from "src/components/(landing)/common/types"
import { StorefrontDetailVariant, StorefrontListProduct, StorefrontVariantOption } from "src/types/storefront"

export function sortProducts(products: StorefrontListProduct[], sortBy: SortValue) {
  if (sortBy === "relevance") {
    products.sort((a, b) => {
      if (a.flags.comingSoon && !b.flags.comingSoon) {
        return 1
      }
      if (!a.flags.comingSoon && b.flags.comingSoon) {
        return -1
      }

      if (a.purchasable && !b.purchasable) {
        return -1
      }
      if (!a.purchasable && b.purchasable) {
        return 1
      }

      if (a.flags.boxOfTheWeek && !b.flags.boxOfTheWeek) {
        return -1
      }
      if (!a.flags.boxOfTheWeek && b.flags.boxOfTheWeek) {
        return 1
      }

      if (a.flags.remainder && !b.flags.remainder) {
        return -1
      }
      if (!a.flags.remainder && b.flags.remainder) {
        return 1
      }

      const aPrice = a.pricing.calculatedPrice || 0
      const bPrice = b.pricing.calculatedPrice || 0

      return aPrice - bPrice
    })
  } else if (sortBy === "created_at") {
    products.sort((a, b) => {
      if (a.flags.comingSoon && !b.flags.comingSoon) {
        return 1
      }
      if (!a.flags.comingSoon && b.flags.comingSoon) {
        return -1
      }

      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    })
  } else if (sortBy === "price_asc") {
    products.sort((a, b) => {
      if (a.flags.comingSoon && !b.flags.comingSoon) {
        return 1
      }
      if (!a.flags.comingSoon && b.flags.comingSoon) {
        return -1
      }

      const aPrice = a.pricing.calculatedPrice
      const bPrice = b.pricing.calculatedPrice

      if (aPrice && !bPrice) {
        return -1
      }
      if (!aPrice && bPrice) {
        return 1
      }

      return (a.pricing.calculatedPrice || 0) - (b.pricing.calculatedPrice || 0)
    })
  } else if (sortBy === "price_desc") {
    products.sort((a, b) => {
      if (a.flags.comingSoon && !b.flags.comingSoon) {
        return 1
      }
      if (!a.flags.comingSoon && b.flags.comingSoon) {
        return -1
      }

      const aPrice = a.pricing.calculatedPrice
      const bPrice = b.pricing.calculatedPrice

      if (aPrice && !bPrice) {
        return -1
      }
      if (!aPrice && bPrice) {
        return 1
      }

      return (b.pricing.calculatedPrice || 0) - (a.pricing.calculatedPrice || 0)
    })
  }
}

export function sortProductVariants(variants: StorefrontDetailVariant[]) {
  return variants.sort((a, b) => (a.pricing.calculatedPrice || 0) - (b.pricing.calculatedPrice || 0))
}

export function sortProductOptions(
  options: StorefrontVariantOption[] | undefined,
  sortedVariants: StorefrontDetailVariant[],
) {
  return options?.map((option) => {
    return {
      ...option,
      variants: option.values.sort((a, b) => {
        const aIndex = sortedVariants.findIndex((variant) =>
          variant.expressions.some((expression) => expression.valueName === a.name),
        )
        const bIndex = sortedVariants.findIndex((variant) =>
          variant.expressions.some((expression) => expression.valueName === b.name),
        )

        return aIndex - bIndex
      }),
    }
  })
}
